import { useState, useEffect, useCallback } from "react";
import { Table, Form, InputGroup, Button } from "react-bootstrap";
import { useTerritorio } from "../../context/TerritorioContext";
import { useBacAuth } from "../../context/BacAuthContext";
import { getPaiVacunacion, exportarBarridoPai, eliminarPaiVacunacion } from "../api/bacSarampionAPI.js";
import { useOnlineStatus, cachearPaiVacunacion, leerPaiVacunacionCache } from "../../hooks/useSync";
import VerPaiModal from "../modal/VerPaiModal";
import CompletarPersonaModal from "../modal/CompletarPersonaModal";
import EditarPaiModal from "../modal/EditarPaiModal";
import Swal from "sweetalert2";
import API from "../../axios.jsx";
import SelectorJornada, { coincideJornada } from "../jornadas/SelectorJornada";
import { exportarFiltradoBac } from "../api/bacSarampionAPI.js";
import { paramsJornada, nombreExcel, descargarBlob } from "../jornadas/exportarExcel";

const IconoCamara = (p) => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2Z" />
    <circle cx="12" cy="13" r="4" />
  </svg>
);

// Íconos SVG — mismo criterio que TablaBacSarampion, sin depender de
// fuentes de emoji.
const IconoOjo = (p) => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);
const IconoMapa = (p) => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0Z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);
const IconoRevisitar = (p) => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M17 1l4 4-4 4" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <path d="M7 23l-4-4 4-4" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);
const IconoEliminar = (p) => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6" /><path d="M14 11v6" /><path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
  </svg>
);
const IconoEditar = (p) => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4Z" />
  </svg>
);
const BTN_ACCION = {
  background: "none", border: "none", cursor: "pointer",
  width: 30, height: 30, borderRadius: 7,
  display: "inline-flex", alignItems: "center", justifyContent: "center",
};

// Personas caracterizadas que NO presentaron carnet ni validación PAIWEB
const sinCarnetDe = (r) => (r.carnets || []).filter(c => c.presenta_evidencia !== "Si");

const TH = { padding: "11px 14px", fontWeight: 600, whiteSpace: "nowrap", fontSize: 12 };
const TD = { padding: "10px 12px", verticalAlign: "middle", fontSize: 13 };
const TD_NUM = { ...TD, textAlign: "center", fontWeight: 700 };
const REGISTROS_PAG = 10;

export default function TablaPaiVacunacion({ onVerEnMapa, puedeExportar = true, esAdmin = false, jornadas = [], filtroJornada = "", onFiltroJornada }) {
  const { data: ctx } = useTerritorio();
  const { usuario } = useBacAuth();
  // El admin siempre puede editar el PAI — quien no es admin, solo si la
  // visita ligada quedó registrada a su propio nombre.
  // En una jornada que no está abierta (cerrada/programada) solo el admin corrige
  const jornadaAbierta = !filtroJornada || jornadas.some(j => coincideJornada(j.codigo, filtroJornada) && j.estado === "abierta");
  const puedeEditar = (r) => esAdmin || (jornadaAbierta && r.visita?.entrevistador && r.visita.entrevistador === usuario?.nombre);
  const [listaBase, setLista]       = useState([]);
  // Filtro de jornada (compartido con Visitas, Mapa y MRCV)
  const lista = listaBase.filter(r => coincideJornada(r.visita?.jornada_codigo, filtroJornada));
  const [cargando, setCargando] = useState(false);
  const [exportando, setExportando] = useState(false);
  const [showVer, setShowVer] = useState(false);
  const [registroVer, setRegistroVer] = useState(null);
  const [registroRevisita, setRegistroRevisita] = useState(null);
  const [showEditar, setShowEditar] = useState(false);
  const [visitaEditar, setVisitaEditar] = useState(null);
  const [cargandoEditar, setCargandoEditar] = useState(false);
  const [showRevisita, setShowRevisita] = useState(false);

  const [busqueda,        setBusqueda]        = useState("");
  const [filtroEntrevistador, setFiltroEntrevistador] = useState("");
  const [fechaInicio,     setFechaInicio]     = useState("");
  const [fechaFin,        setFechaFin]        = useState("");
  const [pagina,          setPagina]          = useState(1);
  const [tarjetaActiva,   setTarjetaActiva]   = useState(null);

  const abrirEditar = (r) => {
    setVisitaEditar(r);
    setShowEditar(true);
  };

  const eliminar = async (r) => {
    const confirmado = await Swal.fire({
      icon: "warning", title: `¿Eliminar el registro PAI de ${r.visita?.codigo_vivienda}?`,
      text: "Esto borra también todas las personas caracterizadas de ese registro.",
      showCancelButton: true, confirmButtonText: "Sí, eliminar", cancelButtonText: "Cancelar", confirmButtonColor: "#b3261e",
    });
    if (!confirmado.isConfirmed) return;
    try {
      await eliminarPaiVacunacion(r.id);
      await cargar();
    } catch (err) {
      Swal.fire("Error", err.response?.data?.message || "No se pudo eliminar", "error");
    }
  };

  // Excel SIEMPRE de la jornada en la que se está. Si la tabla tiene algún
  // filtro aplicado (búsqueda, estado, fechas, tarjeta…), sale solo lo filtrado.
  const exportar = async () => {
    setExportando(true);
    try {
      const params = paramsJornada(ctx, filtroJornada);
      const conFiltro = filtrados.length !== lista.length;
      const res = conFiltro
        ? await exportarFiltradoBac("pai", { params, ids: filtrados.map(r => r.id).filter(Boolean) })
        : await exportarBarridoPai(params);
      descargarBlob(res.data, nombreExcel("PAI_Barrido", ctx, jornadas, filtroJornada, conFiltro));
    } catch {
      alert("No se pudo exportar el Excel de PAI");
    } finally {
      setExportando(false);
    }
  };


  const online = useOnlineStatus();

  const cargar = useCallback(async () => {
    if (!ctx?.territorio) { setLista([]); return; }
    setCargando(true);
    try {
      if (online) {
        const res = await getPaiVacunacion({ territorio: ctx.territorio, comunidad: ctx.comunidad });
        setLista(res.data || []);
        await cachearPaiVacunacion(ctx.territorio, ctx.comunidad, res.data || []);
      } else {
        setLista(await leerPaiVacunacionCache(ctx.territorio, ctx.comunidad));
      }
    } catch {
      // Sin conexión de verdad, o el servidor falló — se cae al caché
      // en vez de dejar la pestaña vacía como si no hubiera nada.
      setLista(await leerPaiVacunacionCache(ctx.territorio, ctx.comunidad));
    } finally {
      setCargando(false);
    }
  }, [ctx?.territorio, ctx?.comunidad, online]);

  useEffect(() => { cargar(); }, [cargar]);
  useEffect(() => { setPagina(1); }, [busqueda, filtroEntrevistador, fechaInicio, fechaFin, tarjetaActiva, filtroJornada]);
  useEffect(() => {
    const handler = () => cargar();
    window.addEventListener("sync-completado", handler);
    return () => window.removeEventListener("sync-completado", handler);
  }, [cargar]);

  // ── Mini-dashboard filtrable — mismo criterio que la pestaña Visitas ──
  const TARJETAS_DASHBOARD = [
    { id: "total",      label: "Total",                  bg: "rgba(255,255,255,0.18)", predicate: () => true },
    { id: "encontrada",  label: "Con población encontrada", bg: "rgba(45,106,79,0.35)",   predicate: r => r.encontrada_total > 0 },
    { id: "vacunado",    label: "Con vacunación en barrido", bg: "rgba(12,68,124,0.35)",   predicate: r => r.vacunada_barrido_total > 0 },
    { id: "no_vacunado", label: "Con NO vacunados",     bg: "rgba(183,121,31,0.35)",  predicate: r => r.no_vacunada_barrido_total > 0 },
    { id: "pendiente",   label: "Biológico pendiente",  bg: "rgba(179,38,30,0.35)",   predicate: r => r.biologico_pendiente === "Si" },
    { id: "sin_carnet",  label: "Con personas sin carnet", bg: "rgba(224,123,0,0.40)",   predicate: r => sinCarnetDe(r).length > 0 },
  ].map(t => ({ ...t, valor: lista.filter(t.predicate).length }));

  const tarjetaSeleccionada = TARJETAS_DASHBOARD.find(t => t.id === tarjetaActiva);

  const entrevistadoresPresentes = [...new Set(lista.map(r => r.visita?.entrevistador).filter(Boolean))].sort();

  const filtrados = lista.filter(r => {
    const q = busqueda.toLowerCase();
    const matchQ = !busqueda
      || r.visita?.codigo_vivienda?.toLowerCase().includes(q)
      || r.visita?.direccion?.toLowerCase().includes(q)
      || r.visita?.entrevistador?.toLowerCase().includes(q)
      || (r.carnets || []).some(c => c.nombre?.toLowerCase().includes(q) || c.numero_identificacion?.toLowerCase().includes(q));
    const matchEntrevistador = !filtroEntrevistador || r.visita?.entrevistador === filtroEntrevistador;
    const fechaRegistro = r.visita?.createdAt?.split("T")[0];
    const matchInicio = !fechaInicio || (fechaRegistro && fechaRegistro >= fechaInicio);
    const matchFin    = !fechaFin    || (fechaRegistro && fechaRegistro <= fechaFin);
    const matchTarjeta = !tarjetaSeleccionada || tarjetaSeleccionada.predicate(r);
    return matchQ && matchEntrevistador && matchInicio && matchFin && matchTarjeta;
  });

  const totalPags = Math.ceil(filtrados.length / REGISTROS_PAG);
  const paginados = filtrados.slice((pagina - 1) * REGISTROS_PAG, pagina * REGISTROS_PAG);

  // Totales poblacionales sobre lo filtrado — contexto propio de PAI,
  // no hay equivalente en la pestaña de Visitas.
  const totalesPob = filtrados.reduce((acc, r) => ({
    encontrados:      acc.encontrados + (r.encontrada_total || 0),
    vacunadosPrevio:  acc.vacunadosPrevio + (r.vacunada_previa_total || 0),
    noVacunados:      acc.noVacunados + (r.no_vacunada_barrido_total || 0),
    vacunadosBarrido: acc.vacunadosBarrido + (r.vacunada_barrido_total || 0),
    sinCarnet:        acc.sinCarnet + sinCarnetDe(r).length,
  }), { encontrados: 0, vacunadosPrevio: 0, noVacunados: 0, vacunadosBarrido: 0, sinCarnet: 0 });

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif" }}>

      {/* Header + dashboard filtrable — mismo esqueleto que Visitas */}
      <div className="bac-hero" style={{
        background: "linear-gradient(135deg, #16342a 0%, #1f4a3a 60%, #2d6a4f 100%)",
        borderRadius: 16, padding: "20px 24px", marginBottom: 20, color: "#fff", position: "relative", overflow: "hidden",
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 12 }}>
          <div>
            <div className="bac-hero-eyebrow" style={{ fontSize: 11, opacity: 0.75, letterSpacing: 1.2, textTransform: "uppercase", marginBottom: 3 }}>
              💉 PAI — Vacunación Sarampión/Rubéola
            </div>
            <h5 style={{ margin: 0, fontWeight: 800, fontSize: "1.15rem" }}>Articulación BAC + Barrido PAI</h5>
            {ctx?.territorio && (
              <div className="bac-hero-lugar" style={{ marginTop: 5, fontSize: 13, opacity: 0.85 }}>
                📍 {ctx.territorio} {ctx.comunidad ? `· 🏘 ${ctx.comunidad}` : ""}
              </div>
            )}
          </div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {TARJETAS_DASHBOARD.map(({ id, label, valor, bg }) => {
              const seleccionada = tarjetaActiva === id;
              return (
                <button key={id} className={`bac-stat${seleccionada ? " is-on" : ""}`} data-tono={id} onClick={() => setTarjetaActiva(seleccionada ? null : id)}
                  title={seleccionada ? "Clic para quitar el filtro" : `Filtrar por: ${label}`}
                  style={{
                    background: bg, borderRadius: 10, padding: "7px 14px", textAlign: "center", minWidth: 70,
                    cursor: "pointer", border: seleccionada ? "2px solid #fff" : "2px solid transparent",
                    boxShadow: seleccionada ? "0 0 0 2px rgba(255,255,255,.5)" : "none",
                  }}>
                  <div style={{ fontSize: "1.1rem", fontWeight: 800, color: "#fff" }}>{valor}</div>
                  <div style={{ fontSize: 10, opacity: 0.9, color: "#fff" }}>{label}</div>
                </button>
              );
            })}
          </div>
        </div>

        {/* Totales poblacionales — propios de PAI */}
        <div className="bac-hero-totales" style={{ display: "flex", gap: 20, marginTop: 14, paddingTop: 12, borderTop: "1px solid rgba(255,255,255,.2)", flexWrap: "wrap" }}>
          {[
            ["Encontrados", totalesPob.encontrados],
            ["Vacunados previamente", totalesPob.vacunadosPrevio],
            ["NO vacunados en barrido", totalesPob.noVacunados],
            ["Vacunados en barrido", totalesPob.vacunadosBarrido],
            ["Personas sin carnet", totalesPob.sinCarnet],
          ].map(([label, valor]) => (
            <div key={label}>
              <div style={{ fontSize: "1.2rem", fontWeight: 800 }}>{valor}</div>
              <div style={{ fontSize: 10.5, opacity: 0.85 }}>{label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Barra de filtros — mismo esqueleto que Visitas, contexto propio */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center", marginBottom: 14 }}>
        <InputGroup style={{ maxWidth: 260, flex: 1 }}>
          <InputGroup.Text style={{ background: "#fff", border: "1.5px solid #dee2e6", borderRight: "none" }}>🔍</InputGroup.Text>
          <Form.Control
            placeholder="Código, dirección, entrevistador o persona..."
            value={busqueda}
            onChange={e => setBusqueda(e.target.value)}
            style={{ fontSize: 13, border: "1.5px solid #dee2e6", borderLeft: "none" }}
          />
        </InputGroup>

        <SelectorJornada jornadas={jornadas} value={filtroJornada} onChange={onFiltroJornada} />

        <Form.Select value={filtroEntrevistador} onChange={e => setFiltroEntrevistador(e.target.value)} style={{ maxWidth: 210, fontSize: 13 }}>
          <option value="">Todos los entrevistadores</option>
          {entrevistadoresPresentes.map(nom => <option key={nom} value={nom}>{nom}</option>)}
        </Form.Select>

        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <label style={{ fontSize: 11.5, color: "#6c757d", whiteSpace: "nowrap" }}>Entre</label>
          <Form.Control type="date" value={fechaInicio} onChange={e => setFechaInicio(e.target.value)} style={{ fontSize: 12.5, maxWidth: 145 }} />
          <span style={{ fontSize: 11.5, color: "#6c757d" }}>y</span>
          <Form.Control type="date" value={fechaFin} onChange={e => setFechaFin(e.target.value)} style={{ fontSize: 12.5, maxWidth: 145 }} />
          {(fechaInicio || fechaFin) && (
            <button onClick={() => { setFechaInicio(""); setFechaFin(""); }} title="Quitar rango"
              style={{ background: "none", border: "none", color: "#b3261e", cursor: "pointer", fontSize: 14 }}>✕</button>
          )}
        </div>

        {puedeExportar && (
          <Button variant="outline-secondary" onClick={exportar} disabled={exportando} style={{ fontSize: 13 }}
            title={filtrados.length !== lista.length ? "Descarga solo las filas que deja el filtro de la tabla" : "Descarga toda la jornada"}>
            {exportando ? "Exportando..." : filtrados.length !== lista.length ? `Exportar Excel (${filtrados.length} filtrados)` : "Exportar Excel de la jornada"}
          </Button>
        )}
      </div>

      {/* Tabla */}
      {cargando ? (
        <p className="text-muted">Cargando...</p>
      ) : (
        <div style={{ background: "#fff", borderRadius: 12, overflow: "hidden", border: "1px solid #e9ecef" }}>
          <div style={{ overflowX: "auto" }}>
            <Table hover style={{ marginBottom: 0 }}>
              <thead style={{ background: "#f8faf8" }}>
                <tr>
                  <th style={TH}>Código vivienda</th>
                  <th style={TH}>Dirección</th>
                  <th style={TH}>Entrevistador</th>
                  <th style={TH}>Fecha</th>
                  <th style={{ ...TH, textAlign: "center" }}>Encontrados</th>
                  <th style={{ ...TH, textAlign: "center" }}>Vac. previo</th>
                  <th style={{ ...TH, textAlign: "center" }}>NO vac. barrido</th>
                  <th style={{ ...TH, textAlign: "center" }}>Vac. barrido</th>
                  <th style={{ ...TH, textAlign: "center" }} title="Personas que no presentaron carnet ni validación en PAIWEB">Sin carnet</th>
                  <th style={TH}>Alertas</th>
                  <th style={TH}>Resultado</th>
                  <th style={TH}>Acción</th>
                </tr>
              </thead>
              <tbody>
                {paginados.map(r => (
                  <tr key={r.id}>
                    <td style={{ ...TD, fontFamily: "monospace", fontSize: 12 }}>{r.visita?.codigo_vivienda}</td>
                    <td style={{ ...TD, maxWidth: 160, whiteSpace: "normal" }}>{r.visita?.direccion || <span className="text-muted">—</span>}</td>
                    <td style={TD}>{r.visita?.entrevistador || <span className="text-muted">—</span>}</td>
                    <td style={TD}>{r.visita?.createdAt?.split("T")[0]}</td>
                    <td style={{ ...TD_NUM, color: "#16342a" }}>{r.encontrada_total}</td>
                    <td style={{ ...TD_NUM, color: "#2d6a4f" }}>{r.vacunada_previa_total}</td>
                    <td style={{ ...TD_NUM, color: "#b3261e" }}>{r.no_vacunada_barrido_total}</td>
                    <td style={{ ...TD_NUM, color: "#0C447C" }}>{r.vacunada_barrido_total}</td>
                    <td style={{ ...TD_NUM, color: sinCarnetDe(r).length ? "#e07b00" : "#adb5bd" }}
                      title={sinCarnetDe(r).map(c => c.nombre).join(", ") || "Todas las personas presentaron carnet o PAIWEB"}>
                      {sinCarnetDe(r).length}{(r.carnets || []).length ? <span style={{ fontWeight: 400, color: "#adb5bd" }}>/{r.carnets.length}</span> : null}
                    </td>
                    <td style={TD}>
                      <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-start" }}>
                        {r.biologico_pendiente === "Si" && (
                          <span className="badge bg-warning text-dark" title={r.biologico_pendiente_detalle || ""}>
                            ⚠️ {r.biologico_pendiente_detalle || "Pendiente"}
                          </span>
                        )}
                        {r.no_vacunada_barrido_total > 0 && (
                          <span className="badge bg-danger" title="Encontrada sin la vacuna de sarampión y sin aplicarla durante este barrido">
                            🚫 {r.no_vacunada_barrido_total} sin vacunar
                          </span>
                        )}
                        {sinCarnetDe(r).length > 0 && (
                          <span className="badge" style={{ background: "#e07b00", color: "#fff" }}
                            title={`No presenta carnet: ${sinCarnetDe(r).map(c => c.nombre).join(", ")}`}>
                            🪪 {sinCarnetDe(r).length} sin carnet
                          </span>
                        )}
                        {r.biologico_pendiente !== "Si" && !(r.no_vacunada_barrido_total > 0) && !sinCarnetDe(r).length && (
                          <span className="text-muted">—</span>
                        )}
                      </div>
                    </td>
                    <td style={TD}>
                      {r.resultado === "Fallida" ? (
                        <span className="badge bg-danger">❌ Fallida</span>
                      ) : (
                        <span className="badge bg-success">✓ Efectiva</span>
                      )}
                    </td>
                    <td style={{ ...TD, whiteSpace: "nowrap" }}>
                      <div style={{ display: "flex", gap: 4 }}>
                        <button onClick={() => { setRegistroVer(r); setShowVer(true); }} title="Ver detalle"
                          style={{ ...BTN_ACCION, color: "#16342a" }}
                          onMouseEnter={e => e.currentTarget.style.background = "#eef1e7"}
                          onMouseLeave={e => e.currentTarget.style.background = "none"}>
                          <IconoOjo />
                        </button>
                        {r.visita?.foto_url && (
                          <button onClick={() => window.open(`${API.defaults.baseURL}${r.visita.foto_url}`, "_blank")} title="Ver foto de la vivienda"
                            style={{ ...BTN_ACCION, color: "#0C447C" }}
                            onMouseEnter={e => e.currentTarget.style.background = "#e7eef7"}
                            onMouseLeave={e => e.currentTarget.style.background = "none"}>
                            <IconoCamara />
                          </button>
                        )}
                        {onVerEnMapa && (
                          <button onClick={() => onVerEnMapa(r.visita?.codigo_vivienda, "pai")} title="Ver en el mapa de barrido PAI"
                            style={{ ...BTN_ACCION, color: "#2d6a4f" }}
                            onMouseEnter={e => e.currentTarget.style.background = "#e4f2e8"}
                            onMouseLeave={e => e.currentTarget.style.background = "none"}>
                            <IconoMapa />
                          </button>
                        )}
                        {r.resultado === "Fallida" && (
                          <button onClick={() => { setRegistroRevisita(r); setShowRevisita(true); }} title="Completar (revisita)"
                            style={{ ...BTN_ACCION, color: "#b7791f" }}
                            onMouseEnter={e => e.currentTarget.style.background = "#faf0dc"}
                            onMouseLeave={e => e.currentTarget.style.background = "none"}>
                            <IconoRevisitar />
                          </button>
                        )}
                        {puedeEditar(r) && (
                          <button onClick={() => abrirEditar(r)} title="Editar" disabled={cargandoEditar}
                            style={{ ...BTN_ACCION, color: "#0C447C" }}
                            onMouseEnter={e => e.currentTarget.style.background = "#e7eef7"}
                            onMouseLeave={e => e.currentTarget.style.background = "none"}>
                            <IconoEditar />
                          </button>
                        )}
                        {esAdmin && (
                          <button onClick={() => eliminar(r)} title="Eliminar registro"
                            style={{ ...BTN_ACCION, color: "#b3261e" }}
                            onMouseEnter={e => e.currentTarget.style.background = "#fbe4e2"}
                            onMouseLeave={e => e.currentTarget.style.background = "none"}>
                            <IconoEliminar />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
                {!paginados.length && (
                  <tr><td colSpan={12} style={{ ...TD, textAlign: "center", color: "#8a94a6", fontStyle: "italic" }}>Sin registros de PAI todavía</td></tr>
                )}
              </tbody>
            </Table>
          </div>

          <div style={{ padding: "10px 20px", background: "#f8faf8", borderTop: "1px solid #e9ecef", fontSize: 12, color: "#6c757d", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
            <span>Mostrando <strong>{paginados.length}</strong> de <strong>{filtrados.length}</strong> · Total registros: <strong>{lista.length}</strong></span>
            {totalPags > 1 && (
              <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                <button onClick={() => setPagina(p => Math.max(1, p - 1))} disabled={pagina === 1}
                  style={{ border: "1px solid #dee2e6", background: "#fff", borderRadius: 6, padding: "3px 10px", fontSize: 12 }}>◀</button>
                <span style={{ fontWeight: 700 }}>{pagina}/{totalPags}</span>
                <button onClick={() => setPagina(p => Math.min(totalPags, p + 1))} disabled={pagina === totalPags}
                  style={{ border: "1px solid #dee2e6", background: "#fff", borderRadius: 6, padding: "3px 10px", fontSize: 12 }}>▶</button>
              </div>
            )}
          </div>
        </div>
      )}

      <VerPaiModal show={showVer} onClose={() => setShowVer(false)} registro={registroVer} />
      <CompletarPersonaModal
        show={showRevisita}
        registro={registroRevisita}
        onClose={() => setShowRevisita(false)}
        onCompletado={cargar}
      />

      <EditarPaiModal
        show={showEditar}
        registro={visitaEditar}
        onClose={() => { setShowEditar(false); setVisitaEditar(null); }}
        onGuardado={cargar}
      />
    </div>
  );
}